import { Link } from 'react-router-dom';
import styles from './Home.module.css';

export default function Home() {
  return (
    <div className="app">
      <div className="background" />

      <header className="header">
        <h1 className="logo">HUNGER GAMES</h1>
        <p className="tagline">6 декабря • 18:00 МСК</p>
      </header>

      <main className="main">
        <section className="hero">
          <div className="hero-content">
            <h1 className={styles.cancellationText}>
              Мероприятие отменено из-за недостаточного количества участников
            </h1>
          </div>
        </section>

        <section className="hero">
          <div className="hero-content">
            <h2 className="greeting">Привет, трибут!</h2>
            <p className="description">
              Добро пожаловать на первые <strong>Голодные игры</strong> от SharagaSquad.
              <br />
              <br />
              Система загружена. Протокол «Жатва» активирован. Вы — испытуемые в этой цифровой
              арене. Ваша цель — не просто выжить, а доминировать. Собирайте ресурсы, создавайте
              тактики и помните: другие трибуты — это не союзники, это ресурс, который скоро
              иссякнет.
              <br />
              <br />
              <strong>Станьте легендой сервера.</strong>
            </p>

            <div className="highlights">
              <div className="highlight">
                <span role="img" aria-label="sword">⚔️</span> Новое оружие
              </div>
              <div className="highlight">
                <span role="img" aria-label="chest">📦</span> Airdrop'ы
              </div>
              <div className="highlight">
                <span role="img" aria-label="fire">🔥</span> Слово пацана
              </div>
            </div>
          </div>
        </section>

        <div className="actions">
          <Link to="notfound" className="btn accent">
            <span>Форма участника</span>
          </Link>
          <Link to="notfound" className="btn primary">
            <span>Telegram</span>
          </Link>
          <Link to="rules" className="btn secondary">
            <span>Информация</span>
          </Link>
        </div>
      </main>

      <footer className="footer">
        <p>© 2025 SharagaSquad</p>
      </footer>
    </div>
  );
}
